module.exports = __webpack_public_path__ + "static/media/signal.aaf2fe66.svg";